import axios from "axios";
import { ENDPOINT_AIRTABLE_FEEDBACK } from "../../qa-search/constants";
import { RUN_LANGSMITH_URL } from "./../constants/index";
import type { FeedbackParams } from "./../types/index";

export const sendFeedback = async (
	params: FeedbackParams,
	feedback: string,
	authToken: string | null,
	// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: na
) => {
	const {
		email,
		type = "Feature",
		appLanguage,
		bundleName,
		currentAppVersion,
		context,
		feature,
		sessionId,
		itemId,
		view,
		platform,
		runId,
		projectId,
		organizationId,
		productId,
		sessionType,
		itemVersionId,
		rating,
	} = params;

	const body = {
		appVersion: currentAppVersion,
		email,
		feedback,
		appLanguage,
		source: type,
		appContext: context,
		featureName: feature,
		currentUrl: view,
		platform,
		bundleId: productId ? productId.toString() : "N/A",
		bundleName,
		sessionId,
		itemId,
		projectId: projectId ? projectId.toString() : "N/A",
		organizationId: organizationId ? organizationId.toString() : "N/A",
		sessionType,
		itemVersionId,
		...(runId ? { aiRunId: runId } : {}),
		...(runId ? { aiTraceId: RUN_LANGSMITH_URL + runId } : {}),
		...(rating ? { rating } : {}),
	};
	try {
		await axios.post(ENDPOINT_AIRTABLE_FEEDBACK, body, {
			headers: authToken ? { Authorization: authToken } : undefined,
		});
	} catch (error) {
		if (axios.isAxiosError(error)) {
			const status = error.response?.status;
			const statusText = error.response?.statusText ?? "";
			const detail =
				typeof error.response?.data === "string"
					? error.response.data.slice(0, 200)
					: "";
			throw new Error(
				`Feedback submission failed [${status} ${statusText}]: ${error.message}${detail ? ` — ${detail}` : ""}`,
				{ cause: error },
			);
		}
		throw new Error("Feedback submission failed with an unexpected error", {
			cause: error,
		});
	}
};
